module.exports = "/_next/static/chunks/fonts/AmsiProNormal-Black-1c2d97cbc92ec93bcdbbf4612abf3910.woff";